import { Shippings } from '@app/pages/checkout-app/types';
import { SelectedMethodInfo } from '../bulk-edit-modal/BulkEditModal';

export const mapShippingToSelectedMethodInfo = (
  method: Shippings,
  groupName: string,
  shopCurrencyCode: string,
): SelectedMethodInfo => ({
  id: method.id,
  shippingMethodId: method.shippingMethodId,
  name: method.name || '',
  groupName,
  currency: method.methodCurrency || shopCurrencyCode || '',
  note: method.notes || '',
  minOrderPriceRange: method.minOrderPriceRange,
  maxOrderPriceRange: method.maxOrderPriceRange,
  rate: method.rate,
  additionalPriceRanges: method.additionalPriceRanges,
  shippingMethodCategory: method.shippingMethod?.category || '',
  polygonInputValues: method.polygonInputValues,
  internationalSettings: method.internationalSettings,
  deliveryAreaSelectMethod: method.deliveryAreaSelectMethod,
  hasDiscount: method.hasDiscount,
  conditions: method.conditions,
  excludedStates: method.polygonInputValues?.[0]?.excludedStates || [],
});
